export const setGiveawayLandingActiveItemTypeCreator = storePrefix => `${storePrefix}SET_GIVEAWAY_LANDING_ACTIVE_ITEM`;
export const setGiveawayLandingActiveItemActionFactory = storePrefix => product => ({
  type: setGiveawayLandingActiveItemTypeCreator(storePrefix),
  payload: product
});
export const removeGiveawayLandingActiveItemTypeCreator = storePrefix => `${storePrefix}REMOVE_GIVEAWAY_LANDING_ACTIVE_ITEM`;
export const removeGiveawayLandingActiveItemActionFactory = storePrefix => (product = '') => ({
  type: removeGiveawayLandingActiveItemTypeCreator(storePrefix),
  payload: product
});